import { render, staticRenderFns } from "./DebriefPage.vue?vue&type=template&id=88f0c4a2&scoped=true"
import script from "./DebriefPage.vue?vue&type=script&lang=js"
export * from "./DebriefPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f0c4a2",
  null
  
)

export default component.exports